export default __webpack_public_path__ + "static/media/adventour-login.ce654bd1.JPG";